import { jsx as _jsx } from "react/jsx-runtime";
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_StatusIndicator.scss';
/**
 * This class will be used as a status indicator for the manual resolver and data
 * criteria panels, in order to show explicitly if a value exists or not or calculation status from the navigator
 */
export class Renderer_StatusIndicator extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.status = nextProps.status;
        return state;
    }
    renderAvailableStatusIndicator = () => {
        if (this.state.status === 'not-available')
            return '';
        const className = _className('status-indicator__active', (this.state.status === 'partial' && !this.props.renderIcon) && 'partial', (this.state.status === 'not-priority-true' && !this.props.renderIcon) && 'not-priority-true');
        const Icon = this.props.icon;
        return _jsx("div", { className: className, children: this.props.renderIcon && _jsx(Icon, { className: 'indicator-icon' }) });
    };
    renderCalcIndication = () => {
        if (this.state.status === null || this.state.status === undefined)
            return '';
        const className = _className('status-indicator__active', this.state.status ? 'true' : 'false');
        return _jsx("div", { className: className });
    };
    resolveMode = () => {
        switch (this.props.mode) {
            case 'status':
                return this.renderAvailableStatusIndicator();
            case 'calc':
                return this.renderCalcIndication();
        }
    };
    render() {
        return _jsx("div", { className: 'status-indicator', children: this.resolveMode() });
    }
}
//# sourceMappingURL=Renderer_StatusIndicator.js.map